/* eslint-disable react/jsx-fragments */

/**
 * The external dependencies
 */

/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import {
  Grid,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import {
  GetChangeDto,
  ProcessProjectForChangeDto,
  ProcessListForChangeDto,
} from '@codefluegel/zeta-change-typescript-client';
import { ChangeEvent, useCallback, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { isChangeManager } from '../../utils/permissionHelper';
import TodoCard from '../../components/TodoCard/TodoCard';

export type ProjectEditResourcePageProps = {
  isTabDataVisible?: boolean;
  projectProcesses?: ProcessProjectForChangeDto[];
  changeProcesses?: ProcessListForChangeDto[];
  handleCheckbox: (processProjectId: number) => void;
  change: GetChangeDto | null;
};

const ProjectEditResourcePage = observer(
  ({
    isTabDataVisible = true,
    projectProcesses,
    changeProcesses,
    handleCheckbox,
    change,
  }: ProjectEditResourcePageProps) => {
    const { t } = useTranslation();

    const isManager = isChangeManager(change);

    const onChange = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        handleCheckbox(Number(e.target.value));
      },
      [handleCheckbox],
    );

    return (
      <Grid
        container
        direction="column"
        css={css`
          display: ${isTabDataVisible ? 'flex' : 'none'};
          padding: 19px 0px 12px 0px;
        `}
      >
        <TodoCard text={t('general.infoText.ChooseResource')} />

        {isManager ? (
          <Fragment>
            {projectProcesses &&
              projectProcesses
                .slice()
                .sort((a, b) => Number(a.groupNo) - Number(b.groupNo))
                .map(prProcess => {
                  const isChecked = changeProcesses?.find(
                    changeProcess => changeProcess.pId === prProcess.id,
                  );
                  return (
                    <FormGroup key={prProcess.id}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!isChecked}
                            onChange={onChange}
                            css={css`
                              svg {
                                color: #00223b;
                              }
                            `}
                          />
                        }
                        value={prProcess.id}
                        label={`${prProcess.name} | ${
                          prProcess.owner ?? ''
                        } | ${prProcess.mandant ?? ''}`}
                        css={css`
                          .MuiTypography-root {
                            font-size: 14px;
                            font-weight: 300;
                            color: #333333;
                          }
                        `}
                      />
                    </FormGroup>
                  );
                })}
          </Fragment>
        ) : (
          <Typography variant="h4">
            {t('change.changeManagerAccess')}
          </Typography>
        )}
      </Grid>
    );
  },
);

export default ProjectEditResourcePage;
